import React from 'react';
import PropTypes from 'prop-types';

import {oeInterfaceManager} from '../../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../../react-oe/oe-interface-adapter';
import OEIcon from '../../../elements/oe-icon';
import OEButton from '../../../elements/controls/oe-button';
import OEAnimationControl from '../../../animation-control/oe-animation-control';
import OEIconCodes from '../../../../lib/oe-icon-codes';
import retardUpdate from '../../../../lib/react/update-retarder';

export default class OEMediaCenterPlayModeControls extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.state = {
            uiEnabled: false,
            canForward: false,
            canBackward: false
        };

        this.onActivePresentationChanged = this.onActivePresentationChanged.bind(this);
        this.onActiveSlideChanged = this.onActiveSlideChanged.bind(this);
        //this.onPresentationAnimateToChanged = this.onPresentationAnimateToChanged.bind(this);
        this.onSlideAdded = this.onSlideAdded.bind(this);
        this.onSlideRemoved = this.onSlideRemoved.bind(this);
        this.onSlideMoved = this.onSlideMoved.bind(this);
        this.onSlideDataChanged = this.onSlideDataChanged.bind(this);

        this.updateCanForwardBackwardState = this.updateCanForwardBackwardState.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.onlyPreviewSlides !== this.props.onlyPreviewSlides || nextProps.wrap !== this.props.wrap || nextProps.noForwardBackwardButtons !== this.props.noForwardBackwardButtons)     {
            this.updateCanForwardBackwardState(nextProps);
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.activePresentationChanged, this.onActivePresentationChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.activePresentationSlideChanged, this.onActiveSlideChanged);
        //this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationAnimateToChanged, this.onPresentationAnimateToChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationSlideAdded, this.onSlideAdded);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationSlideRemoved, this.onSlideRemoved);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationSlideMoved, this.onSlideMoved);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationSlideDataChanged, this.onSlideDataChanged);
    }

    onRelease()  {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.activePresentationChanged, this.onActivePresentationChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.activePresentationSlideChanged, this.onActiveSlideChanged);
        //this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationAnimateToChanged, this.onPresentationAnimateToChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationSlideAdded, this.onSlideAdded);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationSlideRemoved, this.onSlideRemoved);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationSlideMoved, this.onSlideMoved);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationSlideDataChanged, this.onSlideDataChanged);
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.setState({uiEnabled: false, canForward: false, canBackward: false});
            return;
        }

        retardUpdate(this, () => {
            this.setState({ uiEnabled: true });
            this.updateCanForwardBackwardState();
        });
    }

    onActivePresentationChanged()   {
        this.updateCanForwardBackwardState();
    }

    onActiveSlideChanged()  {
        this.updateCanForwardBackwardState();
    }

    /*
    onPresentationAnimateToChanged()    {
        this.updateCanForwardBackwardState();
    }
    */
   
    onSlideAdded()  {
        this.updateCanForwardBackwardState();
    }

    onSlideRemoved()   {
        this.updateCanForwardBackwardState();
    }

    onSlideMoved()   {
        this.updateCanForwardBackwardState();
    }

    onSlideDataChanged()   {
        this.updateCanForwardBackwardState();
    }

    updateCanForwardBackwardState(props) {
        if(!this.oe.isReady()) return;
        let props_ = props || this.props;
        if(props_.noForwardBackwardButtons)  return;
        let controller = this.oe.sharedInterface.getUIControllerPresentation();
        this.setState({ canForward: controller.isNextSlideAvailable(props_.onlyPreviewSlides, props_.wrap), canBackward: controller.isPrevSlideAvailable(props_.onlyPreviewSlides, props_.wrap) });
    }

    render()    {
        const enabled = this.props.enabled && this.state.uiEnabled;

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <div className={'play-mode-controls ' + this.props.className} style={this.props.style}>
                    <div className="control-bar">
                        {this.props.noForwardBackwardButtons ? null :
                            <OEButton
                                className="transparent-btn animation-controls-btn backward"
                                disabled={!(enabled && this.state.canBackward)}
                                onPressed={this.props.onBackwardBtnPressed}
                            >
                                <OEIcon code={OEIconCodes.mcPlayModeBackward}/>
                            </OEButton>
                        }
                        <OEAnimationControl
                            enabled={enabled}
                            slider={{
                                visible: false,
                                enabled: false
                            }}
                            control={{
                                stopBtnVisible: this.props.stopBtnVisible,
                                playBtnVisible: this.props.playBtnVisible,
                                doNotDisableStopBtn: this.props.doNotDisableStopBtn
                            }}
                            adapter={this.props.adapter}
                            onPlayBtnPressed={this.props.onPlayBtnPressed}
                            onPauseBtnPressed={this.props.onPauseBtnPressed}
                            onStopBtnPressed={this.props.onStopBtnPressed}
                        />
                        {this.props.noForwardBackwardButtons ? null :
                            <OEButton
                                className="transparent-btn animation-controls-btn forward"
                                disabled={!(enabled && this.state.canForward)}
                                onPressed={this.props.onForwardBtnPressed}
                            >
                                <OEIcon code={OEIconCodes.mcPlayModeForward}/>
                            </OEButton>
                        }
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

OEMediaCenterPlayModeControls.defaultProps = {
    className:                  '',
    moduleId:                   '',
    enabled:                    true,
    onlyPreviewSlides:          false,
    wrap:                       false,
    playBtnVisible:             true,
    stopBtnVisible:             true,
    doNotDisableStopBtn:        true,
    noForwardBackwardButtons:   false
};

OEMediaCenterPlayModeControls.propTypes = {
    moduleId:                   PropTypes.string,
    className:                  PropTypes.string,
    style:                      PropTypes.object,
    enabled:                    PropTypes.bool,
    onlyPreviewSlides:          PropTypes.bool,
    wrap:                       PropTypes.bool,
    playBtnVisible:             PropTypes.bool,
    stopBtnVisible:             PropTypes.bool,
    doNotDisableStopBtn:        PropTypes.bool,
    noForwardBackwardButtons:   PropTypes.bool,
    adapter:                    PropTypes.object,
    onPlayBtnPressed:           PropTypes.func,
    onPauseBtnPressed:          PropTypes.func,
    onStopBtnPressed:           PropTypes.func,
    onForwardBtnPressed:        PropTypes.func,
    onBackwardBtnPressed:       PropTypes.func
};